import React, {useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';

// <Link> supports hashes natively; scroll-to-anchor is handled by <HashScroller> (mounted once in App)
export function HashLink({to, ...props}) {
  return <Link to={to} {...props} />;
}

export function HashScroller() {
  const {hash} = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView({behavior: 'smooth', block: 'start'});
  }, [hash]);
  return null;
}
